export default function PieStudio({setData, form}) {

    return (
        <>
            <div className={'location_studio_container'}>
                <button className={'studio' + (form?.pieLocation === 'basel' ? ' studio_selected' : '')} onClick={(e) => setData({pieLocation: 'basel'})}>
                    PIE Basel
                </button>
                <button className={'studio' + (form?.pieLocation === 'zürich' ? ' studio_selected' : '')} onClick={(e) => setData({pieLocation: 'zürich'})}>
                    PIE Zürich
                </button>
            </div>
        </>
    );
}